import { GraphQL } from "@graphql/graphQL";
import { UpdateApplianceCategoryMutation, UpdateApplianceCategoryMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultUpdateApplianceCategoryOptions: MutationHookOptions<UpdateApplianceCategoryMutation, UpdateApplianceCategoryMutationVariables> = {

};

export const useUpdateApplianceCategory = (options?: MutationHookOptions<UpdateApplianceCategoryMutation, UpdateApplianceCategoryMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: UpdateApplianceCategoryMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<UpdateApplianceCategoryMutation, UpdateApplianceCategoryMutationVariables>(GraphQL.updateApplianceCategory);

    const updateApplianceCategory = async (variables: UpdateApplianceCategoryMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultUpdateApplianceCategoryOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (error) {
            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    const clearErrors = () => {
        setHookState({
            ...hookState,
            error: undefined
        });
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        updateApplianceCategory,
        clearErrors
    };
};
